import type { DioramaState } from 'app/state/diorama/dioramaState';
import { getLocalizedText, getLocalizedValue } from '@softgames/localization';
import MathUtils from 'utils/MathUtils';
import type { DioramaProgressBarLayout } from '../../../libs/layouts/types/LayoutShapes';
import * as DioramaStateUtils from '../../../app/state/diorama/DioramaStateUtils';

// Using centralized DioramaProgressBarLayout

export class DioramaProgressBarView {
  private readonly maxBarWidth: number;

  private currentPieces = 0;

  private totalPieces = 0;

  private additionalPieces = 0;

  constructor(
    private readonly layout: DioramaProgressBarLayout,
    private readonly dioramaState: DioramaState,
    private readonly hasChest: boolean,
  ) {
    this.maxBarWidth = layout.dioramaProgressBarFill.width;

    layout.dioramaProgressBarFill.width = 0;
  }

  public setProgress(dioramaIndex: number): void {
    this.totalPieces = DioramaStateUtils.getDioramaNumberOfPieces(dioramaIndex);

    if (dioramaIndex <= this.dioramaState.dioramaIndex) {
      const isDioramaInProgress = dioramaIndex === this.dioramaState.dioramaIndex;

      this.currentPieces = isDioramaInProgress
        ? DioramaStateUtils.getDioramaCompletedPieces(this.dioramaState)
        : this.totalPieces;
    } else {
      this.currentPieces = 0;
    }

    this.updateView(false);
  }

  public addTilesToProgress(additionalPieces: number): void {
    this.additionalPieces = additionalPieces;

    this.updateView(true);
  }

  public reset(): void {
    this.additionalPieces = 0;

    this.currentPieces = 0;
    this.totalPieces = 0;

    this.updateView(false);
  }

  private updateView(animateBar: boolean): void {
    const pieces = this.currentPieces + this.additionalPieces;

    const progress = MathUtils.clamp(pieces / this.totalPieces, 0, 1);

    const barWidth = this.hasChest && progress < 1 ? this.maxBarWidth - 60 : this.maxBarWidth;

    if (animateBar) {
      this.layout.dioramaProgressBarFill.tweenTo({ width: progress * barWidth }, 200, 'quadOut', true);
    } else {
      this.layout.dioramaProgressBarFill.width = progress * barWidth;
    }

    if (this.layout.countText != null) {
      this.layout.countText.text =
        pieces === this.totalPieces
          ? getLocalizedText('Complete!')
          : `${getLocalizedValue(pieces)}/${getLocalizedValue(this.totalPieces)}`;
    }
  }
}
